<template>
  <card>
    <list
      v-if="$store.state.user.is_root"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "business",
      fields: [
        {
          key: "title",
          label: "Названи школы",
          isMultiLang: true,
          type: "field",
          textType: "text",
        },
        {
          col: "col-12",
          label: "Город / район",
          key: "cloud_location_id",
          type: "location",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_business",
      itemLink: "businesses",
      setLink: "businesses",
      columns: [
        {
          key: "is_active",
          title: "",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
